import { useEffect } from 'react';
import chatr from './img/chatr.png'
import lucky from './img/lucky.png'
import koodo from './img/koodo.png'
import { createSearchParams,NavLink } from 'react-router-dom';

function Carrier() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div>
    <div style={{display:'flex', flexDirection:'row', width:'100%'}}><div style={{width:'100%'}}><h1 style={{justifySelf:"center", borderBottom: '1px solid #e6e6e6', margin: "0px", padding: "20px"}}>Please choose a plan</h1></div></div>
    <div style={{display:'flex', flexWrap:'wrap',justifyContent:'space-evenly', alignItems:'center', width:'100%', height:'80vh'}}>
      <NavLink to={{ pathname: '/planslucky', search: createSearchParams({ carrier: 'Chatr' }).toString() }} ><img src={chatr} height='250' style={{ borderRadius: 40 }} /></NavLink>
      <NavLink to={{ pathname: '/planslucky', search: createSearchParams({ carrier: 'Lucky' }).toString() }}><img src={lucky} height='250' /></NavLink>
      <NavLink to={{ pathname: '/planslucky', search: createSearchParams({ carrier: 'Koodo' }).toString() }}><img src={koodo} height='250' style={{ borderRadius: 40 }} /></NavLink>
    </div></div>
 );
}

export default Carrier;
